import React from "react";
import "./Plans.css";
import { plansData } from "../../data/plansData";
import RightArrow from "../../assets/rightArrow.png";
import whiteTick from "../../assets/whiteTick.png";

const Plans = () => {
  return (
    <div className="plans-container">
      <div className="blur plans-blur-1"></div>
      <div className="blur plans-blur-2"></div>
      <div className="plans-header">
        <span className="stroke-text">ready to start</span>
        <span>your jorney </span>
        <span className="stroke-text">now with us</span>
      </div>

      <div className="plan-cards">
        {plansData.map((plan, i) => (
          <div className="plan-category" key={i}>
            {plan.icon}
            <span>{plan.name}</span>
            <span>$ {plan.price}</span>

            <div className="features">
              {plan.features.map((feature, i) => (
                <div className="ft">
                  <img src={whiteTick} alt="" />
                  <span key={i}>{feature}</span>
                </div>
              ))}
            </div>

            <div className="benefits">
              <span>See more benefits</span>
              <img src={RightArrow} alt="" />
            </div>

            <button className="btn">Join now</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Plans;
